import { Pipe, PipeTransform } from '@angular/core';

const PADDING = '000000';

@Pipe({ name: 'paperCurrency' })
export class PaperCurrencyPipe implements PipeTransform {
    private DECIMAL_SEPARATOR: string;
    private THOUSANDS_SEPARATOR: string;

    constructor() {
        // Comes from configuration settings
        this.DECIMAL_SEPARATOR = '.';
        this.THOUSANDS_SEPARATOR = ',';
    }

    // YS: Now handle proper float manipulation as well. For example 4.399999 is now made to be 4.40
    transform(value: number | string, fractionSize: number = 2, negative_parantheses: boolean = false): string {
        //

        let transformed_number = '';

        if (value != null && value != undefined) {
            let stringed_value: string = value.toString();

            //

            // YS: Sanitize all special chars '()', '/', etc, except '-' because it means negative number
            let sanitized_value = stringed_value.replace(/[`~!@#$%^&*()_|+,?;:'"<>\]\\]/gi, '');
            let parsed_float = parseFloat(sanitized_value);

            //

            if (!isNaN(parsed_float)) {
                stringed_value = parsed_float.toFixed(2);
                transformed_number = this.processNonNullValue(parsed_float, stringed_value, fractionSize);
            } else {
                // YS: String is not a number (can be 1.000.000,00), thus return the original string on this case
                transformed_number = stringed_value;
            }

            // YS: To handle Negative Case with parantheses, in such cases, return back the parantheses
            if (parsed_float < 0 && negative_parantheses) {
                if (transformed_number.startsWith('-')) {
                    transformed_number = transformed_number.slice(1);
                }
                transformed_number = '(' + transformed_number + ')';
            }
        }

        //
        return transformed_number;
    }

    // YS: to handle transforming format when typing
    // main difference, this one doesn't do any float manipulation
    transformInPlace(value: number | string, fractionSize: number = 2, negative_parantheses: boolean = false): string {
        //

        let transformed_number = '';

        if (value != null && value != undefined) {
            let stringed_value = value.toString();

            //
            let fullnumber = stringed_value;
            let [integer, fraction = ''] = (stringed_value || '').toString().split(this.DECIMAL_SEPARATOR);

            //

            integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);
            fullnumber = fullnumber.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);

            if (fraction && fraction.length > 2) {
                fraction = this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize);
                fullnumber = integer + fraction;
            }

            transformed_number = fullnumber;
            // YS: To handle Negative Case with parantheses
            let new_value = parseInt(value + '');

            if (new_value < 0 && negative_parantheses) {
                if (transformed_number.startsWith('-')) {
                    transformed_number = transformed_number.slice(1);
                }
                transformed_number = '(' + transformed_number + ')';
            }
        }

        //
        return transformed_number;
    }

    parse(value: string, fractionSize: number = 2): string {
        //
        let integer_parsed = '';
        if (value) {
            // YS: Cleanup Parenthesis
            value = value.replace(/[\])}[{(]/g, '');

            //
            let integer = value.replace(new RegExp(this.THOUSANDS_SEPARATOR, 'g'), '');

            //
            integer_parsed = integer;
        }

        //
        return integer_parsed;
    }

    // AFG: get transformed number for non null value
    processNonNullValue(parsed_float: number, stringed_value: string, fractionSize: number) {
        //
        let fullnumber = stringed_value;
        let [integer, fraction = ''] = (stringed_value || '').toString().split(this.DECIMAL_SEPARATOR);

        //

        integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);
        fullnumber = fullnumber.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);

        if (fraction && fraction.length > 2 && fractionSize !== -1) {
            fraction = this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize);
            fullnumber = integer + fraction;
        }

        if (fractionSize === -1) {
            fullnumber = integer;
        }

        return fullnumber;
    }
}
